import { lazy } from 'react';

export const LottieWrapper = lazy(() => import('./LottieWrapper'));
